// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-rust-detector-task-dialog[data-v-59651477] .el-dialog{width:var(--common-dialog-large-width)}.create-rust-detector-task-dialog .el-form[data-v-59651477]{margin-right:var(--base-size-48)}.create-rust-detector-task-dialog .el-select[data-v-59651477]{width:100%}", ""]);
// Exports
module.exports = exports;
